import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-instagram"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 12C2 8.26154 2 6.3923 2.80385 5C3.33046 4.08788 4.08788 3.33046 5 2.80385C6.3923 2 8.26154 2 12 2C15.7385 2 17.6077 2 19 2.80385C19.9121 3.33046 20.6695 4.08788 21.1962 5C22 6.3923 22 8.26154 22 12C22 15.7385 22 17.6077 21.1962 19C20.6695 19.9121 19.9121 20.6695 19 21.1962C17.6077 22 15.7385 22 12 22C8.26154 22 6.3923 22 5 21.1962C4.08788 20.6695 3.33046 19.9121 2.80385 19C2 17.6077 2 15.7385 2 12Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 12C2 8.26154 2 6.39231 2.80385 5C3.33046 4.08788 4.08788 3.33046 5 2.80385C6.39231 2 8.26154 2 12 2C15.7385 2 17.6077 2 19 2.80385C19.9121 3.33046 20.6695 4.08788 21.1962 5C22 6.39231 22 8.26154 22 12C22 15.7385 22 17.6077 21.1962 19C20.6695 19.9121 19.9121 20.6695 19 21.1962C17.6077 22 15.7385 22 12 22C8.26154 22 6.39231 22 5 21.1962C4.08788 20.6695 3.33046 19.9121 2.80385 19C2 17.6077 2 15.7385 2 12Z","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M17.75 6.25H17.7539V6.25391H17.75V6.25Z","strokeLinejoin":"round","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12Z","strokeLinejoin":"round","strokeWidth":"props.strokeWidth"}}]}]}]};

const LogoInstagram = Vue.extend<IconProps>({
  name: 'LogoInstagramIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-instagram',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoInstagram;
